<template>
          <v-card flat>
            <v-card-title>
                <span class="headline">Generate Config File</span>
            </v-card-title>
            <v-card-text>
                <strong>Enter Service Account Credentials:</strong>
                <v-form v-model="valid" @submit.prevent>
                  <v-layout wrap>
                  <v-flex xs12 lg5 ma-2>
                    <v-autocomplete
                    :autofocus="false"
                     autocomplete="off"
                     :hide-no-data="true"
                      v-model="email"
                      :items="allUsers"
                      :rules="[rules.required]"
                      prepend-icon="fas fa-user"
                      label="Service Account"
                      item-text="login"
                      item-value="login">
                    </v-autocomplete>
                    <v-text-field autocomplete="off"
                      v-model="password"
                      id="password" :rules="[rules.required]"
                      prepend-icon="fas fa-lock" name="password"
                      label="Password" type="password">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 lg5 ma-2>
                    <h3>Collection Options:</h3>
                      <v-radio-group v-model="options">
                        <v-radio label="All (Endpoints and Infrastructure)" value="All"></v-radio>
                        <v-radio label="Endpoints Only" value="EPM-Only"></v-radio>
                        <v-radio label="Infrastructure Only" value="Systems-Only"></v-radio>
                        <!-- <v-radio v-if="options === 'Specific' || options === 'All' || options === 'Systems-Only'" label="Specific Drivers" value="Specific"></v-radio> -->
                        <v-select
                          v-if="options === 'Specific'"
                          label="Select Drivers"
                          v-model="selectedDrivers"
                          :items="drivers"
                          :menu-props="{ maxHeight: '400' }"
                          multiple
                        ></v-select>
                      </v-radio-group>
                  </v-flex>
                  </v-layout>
                  <v-layout wrap>
                  <v-flex ma-2>
                    <h3>Proxy Details:</h3>
                    <span class="caption">
                    Is there a proxy server that the collector must use to reach infrastructure, endpoints and the WXP Collaboration Cloud?
                    </span>
                    <v-layout wrap>
                        <v-flex xs4 mr-4>
                        <v-select :items="proxyTypes" v-model="selectedProxyType"
                          ></v-select>
                        </v-flex>

                        <template v-if="selectedProxyType === 'https'">
                          <v-flex xs4 mr-4>
                            <v-text-field v-model="proxyserver" label="Proxy server" :rules="[rules.required]" ></v-text-field>
                          </v-flex>
                          <v-flex xs4 mr-4>
                            <v-text-field v-model="proxyport" label="Proxy port"></v-text-field>
                          </v-flex>
                          <v-flex xs4 mr-2>
                            <v-text-field v-model="proxyusername" label="Proxy username" prepend-icon="fas fa-user"></v-text-field>
                          </v-flex>
                          <v-flex xs4>
                            <v-text-field v-model="proxypassword" prepend-icon="fas fa-lock" label="Proxy password" type="password"></v-text-field>
                          </v-flex>
                        </template>
                    </v-layout>
                      <v-layout v-if="selectedProxyType !== null">
                        <v-flex xs8 ma-1>
                          <v-textarea v-model="proxybypasslist" hint="Use commas to separate multiple addresses"
                          persistent-hint
                           label="Bypass list"></v-textarea>
                        </v-flex>
                     </v-layout>
                    </v-flex>
                  </v-layout>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" outlined rounded :disabled="!valid" v-on:click="getConfigFile()">Get Config File</v-btn>
            </v-card-actions>
        </v-card>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import _ from 'lodash'
export default {
  props: {
    defaultLogin: String
  },
  data() {
    return {
      email: null,
      valid: false,
      password: null,
      proxyTypes: [
        {text: 'No Proxy', value: null},
        {text: 'Auto Discover', value: 'auto'},
        {text: 'Set Proxy', value: 'https'},
        // {text: 'Http Proxy', value: 'http'},
        // {text: 'Socks Proxy', value: ''}
      ],

      selectedProxyType: null,

      proxyserver: null,
      proxyport: null,
      proxyusername: null,
      proxypassword: null,

      proxybypasslist: null,

      options:"All",
      selectedDrivers: [],
      drivers: [
        {text: 'CMS', value: '.*cms.*'},
        {text: 'CUBE', value: '.*cube.*'},
        {text: 'CUCM', value: '.*cucm.*'},
        {text: 'EXCHANGE', value: '.*exch.*'},
        {text: 'PEXIP', value: '.*pexip.*'},
        {text: 'SKYPE', value: '.*skype.*'},
        {text: 'TMS', value: '.*tms.*'},
        {text: 'VCS', value: '.*vcs.*'}
        ],
      rules: {
        required: value => !!value || 'Required.'
      }
    }
  },
  computed: {
      ...mapGetters('user', {
          allUsers: 'adminUsers',
        orgContext: 'getOrgContext'
      })
  },
  watch: {
    orgContext: async function(val) {

      this.fetchAndSetByPassList()

    }
  },
  async created() {
    this.email = this.defaultLogin
    this.fetchAndSetByPassList()
  },
  methods: {
    async getConfigFile() {
        if (await this.$store.dispatch('collectors/getConfigFile', {email: this.email,
                                password: this.password,
                                proxy: {
                                  type: this.selectedProxyType, bypassList: this.proxybypasslist,
                                  server: this.proxyserver, port: this.proxyport,
                                  username: this.proxyusername, password: this.proxypassword
                                },
                                options: this.options, details: this.selectedDrivers.join('|')
                                })) {
            this.$emit('success', this.property)
        }
    },
    async fetchAndSetByPassList() {
      this.proxybypasslist = await this.$store.dispatch('systems/getExtraConfigValueForKey', 'van.proxy.bypass.list')
    }
  }

}
</script>
